import { render } from "./SurveyDashboard.vue?vue&type=template&id=fbcf3d32&scoped=true"
import script from "./SurveyDashboard.vue?vue&type=script&lang=js"
export * from "./SurveyDashboard.vue?vue&type=script&lang=js"

import "./SurveyDashboard.vue?vue&type=style&index=0&id=fbcf3d32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbcf3d32"]])

export default __exports__